import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    SRC: {
        id: 'spareParts.priorityType.option.src',
        defaultMessage: 'SRC'
    },
    VOR: {
        id: 'spareParts.priorityType.option.vor',
        defaultMessage: 'VOR'
    },
    OTS_ACTIS: {
        id: 'spareParts.priorityType.option.otsActisSolution',
        defaultMessage: 'OTS/ACTIS solution'
    },
});

export default messages;
